import { useEffect, useState } from 'react';
import { api, getToken } from '../../../lib/api';
import { countActiveClaims } from '../../../lib/claimStatus';

/**
 * The signed-in user's ACTIVE claim codes (unredeemed, unexpired: lib/claimStatus), for the
 * header's wallet badge. Same request and rules as the legacy header: GET /deals/my-claims,
 * only with a session token; a failure (e.g. a 401 while the session settles) counts 0.
 */
export default function useActiveClaimsCount(isAuthenticated, userId) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let live = true;
    if (!isAuthenticated || !userId || !getToken()) {
      setCount(0);
      return undefined;
    }
    api.get('/deals/my-claims')
      .then(({ data }) => { if (live) setCount(countActiveClaims(data)); })
      .catch(() => { if (live) setCount(0); });
    return () => { live = false; };
  }, [isAuthenticated, userId]);

  return count;
}
